export const EstadosCredencial = {
    1: 'PENDIENTE DE ACTIVACION',
    2: 'ACTIVA',
    3: 'SUSPENDIDA',
    4: 'BAJA',
    5: 'BAJA PENDIENTE',
}